import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegionesService } from '../../../services/regiones.service';

@Component({
  selector: 'app-subregion',
  templateUrl: './subregion.component.html',
  styleUrls: ['./subregion.component.css']
})
export class SubregionComponent implements OnInit {
  subRegion: any;
  ID_REGION: any;
  errorModal: any;
  form: FormGroup;
  loading = false;
  regiones = [];
  modals: any;
  constructor( public activeModal: NgbActiveModal,
    private regionService: RegionesService) {

    }

  ngOnInit() {
    this.form = new FormGroup({
      'ID_SUB_REGION': new FormControl(this.subRegion.ID_SUB_REGION ? this.subRegion.ID_SUB_REGION : ''),
      'ID_REGION': new FormControl({value: this.subRegion.ID_SUB_REGION ? this.subRegion.ID_REGION : this.ID_REGION,
                                    disabled: true }),
      'nombre': new FormControl(this.subRegion.ID_SUB_REGION ? this.subRegion.nombre : '', Validators.required)
    });
    const subcription = this.regionService.regiones().subscribe( regiones => {
      this.regiones = regiones;
      subcription.unsubscribe();
    });
  }

  guardar() {
    this.loading = true;
    const subcription = this.regionService.registrarEditarSubRegion(this.form.getRawValue()).subscribe(res => {
      subcription.unsubscribe();
    this.loading = false;
    this.activeModal.close(res);
    }, error => {
      this.modals.validacionesModalJquery('', error.error,
      'red',
      'modern',
      false);
      subcription.unsubscribe();
      this.loading = false;
    });
  }

}




// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/subregion/subregion.component.ts